import { withAPIAccount } from '../../lib/http/api';
import { parsedResponse } from '../../lib/http/http';
import { AccountType, IAPIresponse } from '../../model';
import { STUDIO_PREFIX } from '../config';

// 用户主动申请加入
export const studioApply = (studioId: string, Reason: string) =>
  withAPIAccount(AccountType.auto, async (api): Promise<IAPIresponse> => {
    try {
      const url = `${STUDIO_PREFIX}/${studioId}/apply`;
      const response = await api.commonRequest('POST', url, { Reason });
      return await parsedResponse<IAPIresponse>(response, 'data');
    } catch (error) {
      console.log(error);
      //  if (error instanceof APIError) {
      //   messageError(error.message);
      // }
      return {};
    }
  });
